import { XCircle, Home, MessageCircle } from "lucide-react";
import { useSearchParams } from "react-router-dom";

/**
 * Iter 135 — Página de cancelación tras rechazar/cancelar el pago PayPal.
 */
export default function PaymentCancelled() {
  const [params] = useSearchParams();
  const orderId = params.get("token") || params.get("order_id") || "";

  return (
    <div className="min-h-screen bg-[#F5F5F0] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border border-[#111110] shadow-2xl">
        <div className="bg-[#B84A2A] text-white px-6 py-4 flex items-center gap-3">
          <XCircle size={28} />
          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest opacity-80">iRepairs.es</div>
            <h1 className="font-display font-black text-xl">Pago cancelado</h1>
          </div>
        </div>
        <div className="px-6 py-8 text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
            <XCircle size={40} className="text-orange-700" />
          </div>
          <h2 className="font-display text-2xl font-black">No se ha completado el pago</h2>
          <p className="text-sm text-gray-700 leading-relaxed">
            Has cancelado el pago o se ha interrumpido. No se te ha cobrado nada.
            Si quieres intentarlo de nuevo, puedes utilizar el mismo enlace que
            te enviamos por email o WhatsApp.
          </p>
          <p className="text-sm text-gray-700">
            Si tienes cualquier duda o problema, contacta con nosotros.
          </p>
          {orderId && (
            <div className="text-[11px] text-gray-500 font-mono border-t pt-3">
              Ref. PayPal: <span className="break-all">{orderId}</span>
            </div>
          )}
          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-2">
            <a
              href="https://irepairs.es"
              className="inline-flex items-center gap-2 border border-[#111110] hover:bg-[#111110] hover:text-white px-4 py-2 text-sm w-full sm:w-auto justify-center"
              data-testid="payment-cancel-home-btn"
            >
              <Home size={14} /> Ir a irepairs.es
            </a>
            <a
              href="https://wa.me/34628712498"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5D] text-white px-4 py-2 text-sm w-full sm:w-auto justify-center"
              data-testid="payment-cancel-whatsapp-btn"
            >
              <MessageCircle size={14} /> Contactar por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
